import React from "react";
import { useGlobalContext } from "../components/Context";
import "../scss/Modal.scss";
import { FaTimes } from "react-icons/fa";

const Modal = () => {
	const { openModal, handleModal } = useGlobalContext();
	return (
		<>
			{openModal && (
				<div className="modal">
					<div className="modal__wrapper">
						<div className="modal__top">
							<p>IExchange – the currency Marketplace</p>
							<FaTimes onClick={handleModal} />
						</div>
						<div className="modal__bottom">
							<p>
								Thank you for joining the iExchange early access list. You will
								be notified when we launch our private beta.
							</p>
							<p>
								Want to skip to the front of the queue? Tweet about iExchange
								and tag @iExchangeNG1 for faster onboarding. (Thank you for
								this, it’s quite helpful to us
							</p>
							<p>
								E.g. Hello there! I recently signed up to @iExchangeNG1 waiting
								list to get alternative solution to exchange currencies the easy
								and convenient way. You should sign up for their waiting list
								too at <a href="www.iexchangeng.com">www.iexchangeng.com</a>
							</p>
							<p>Talk about @iExchangeNG1</p>
							<p>
								If you have any questions about how iExchange works, feel free
								to reach out to us at
								<a href="mailto:info@iexchangeng.com">info@iexchangeng.com</a>
							</p>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Modal;
